export default __webpack_public_path__ + "static/pressnxpress-touchless-customer-feedback-kiosk-d71f9c1bd4f549e46ee1c572d262828d.webp";